import styled from "@emotion/styled";

export const ChartActionsContainer = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 10;

  display: flex;
  align-items: center;
  gap: 8px;
`;

export const MobileUpdatedAtWrapper = styled.div`
  margin-bottom: 16px;
`;
